import { HttpService } from "../http/HttpService";
import {
    ListPendingTransactionsRequest,
    ListPendingTransactionsResponse,
    RejectPendingTransactionRequest,
} from "../http/protocol";

export class SupervisorService {
    constructor(private http: HttpService) {}

    countPendingTransactions(): Promise<{ count: number }> {
        return this.http.get("/pending-budget-transaction/count");
    }

    getPendingTransactions(req: ListPendingTransactionsRequest): Promise<ListPendingTransactionsResponse> {
        return this.http.post("/pending-budget-transaction/list", req);
    }

    approvePendingTransaction(id: number): Promise<void> {
        return this.http.post(`/pending-budget-transaction/approve/${id}`, undefined);
    }

    rejectPendingTransaction(id: number, req: RejectPendingTransactionRequest): Promise<void> {
        return this.http.post(`/pending-budget-transaction/reject/${id}`, req);
    }
}
